import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Layout from './components/layout/Layout';
import MobileLayout from './components/layout/mobile/MobileLayout'; 
import Dashboard from './components/layout/Dashboard';
import MobileDashboard from './components/layout/mobile/MobileDashboard'; 
import ScreenDetails from './components/layout/ScreenDetails'; 
import MobileScreenDetails from './components/layout/mobile/MobileScreenDetails';
import MediaLibrary from './components/layout/MediaLibrary';
import MobileMediaLibrary from './components/layout/mobile/MobileMediaLibrary';
import RegistrationCenter from './components/layout/RegistrationCenter';
import MobileRegistrationCenter from './components/layout/mobile/MobileRegistrationCenter';
import Playlist from './components/layout/Playlist';
import MobilePlaylist from './components/layout/mobile/MobilePlaylist';
import RegisterMachines from './components/layout/RegisterMachines'; 
import MobileRegisterMachines from './components/layout/mobile/MobileRegisterMachines';
import MachineMappings from './components/layout/MachineMappings'; 
import MobileMachineMappings from './components/layout/mobile/MobileMachineMappings';
import VideoEditor from './components/layout/VideoEditor';
import VideoEditor2 from './components/layout/VideoEditor2'; // IMPORT NOVE STRANE
import MobileVideoEditor from './components/layout/mobile/MobileVideoEditor';
import TelegramUsers from './components/layout/TelegramUsers';
import MobileTelegramUsers from './components/layout/mobile/MobileTelegramUsers';
import Login from './components/layout/Login';
import Users from './components/layout/Users';
import MobileUsers from './components/layout/mobile/MobileUsers';
import MobileBoxManagement from './components/layout/mobile/MobileBoxManagement';
import BoxManagement from './components/layout/BoxManagement';

axios.defaults.baseURL = 'https://escreen.stand.ledscreen.rs';
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Token ${token}`;
}

function App() {
  const isAuthenticated = !!localStorage.getItem('token');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/*"
          element={
            isAuthenticated ? (
              isMobile ? (
                <Routes>
                  <Route path="/" element={<MobileLayout title="Dashboard"><MobileDashboard /></MobileLayout>} />
                  <Route path="/screendetails/:id" element={<MobileLayout title="Screen Details"><MobileScreenDetails /></MobileLayout>} />
                  <Route path="/media" element={<MobileLayout title="Media Library"><MobileMediaLibrary /></MobileLayout>} />
                  <Route path="/registration" element={<MobileLayout title="Registration"><MobileRegistrationCenter /></MobileLayout>} />
                  <Route path="/playlists" element={<MobileLayout title="Playlists"><MobilePlaylist /></MobileLayout>} />
                  <Route path="/register-machine" element={<MobileLayout title="Register Machine"><MobileRegisterMachines /></MobileLayout>} />
                  <Route path="/mappings" element={<MobileLayout title="Mappings"><MobileMachineMappings /></MobileLayout>} />
                  <Route path="/video-editor" element={<MobileLayout title="Video Editor"><MobileVideoEditor /></MobileLayout>} />
                  <Route path="/video-editor-2" element={<MobileLayout title="Video Editor 2"><VideoEditor2 /></MobileLayout>} />
                  <Route path="/telegram-users" element={<MobileLayout title="Telegram"><MobileTelegramUsers /></MobileLayout>} />
                  <Route path="/users" element={<MobileLayout title="Users"><MobileUsers /></MobileLayout>} />
                  <Route path="/box-management" element={<MobileLayout title="Box Management"><MobileBoxManagement /></MobileLayout>} />
                </Routes>
              ) : (
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/screendetails/:id" element={<ScreenDetails />} />
                    <Route path="/media" element={<MediaLibrary />} />
                    <Route path="/registration" element={<RegistrationCenter />} />
                    <Route path="/playlists" element={<Playlist />} />
                    <Route path="/register-machine" element={<RegisterMachines />} />
                    <Route path="/mappings" element={<MachineMappings />} />
                    <Route path="/video-editor" element={<VideoEditor />} />
                    <Route path="/video-editor-2" element={<VideoEditor2 />} />
                    <Route path="/telegram-users" element={<TelegramUsers />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/box-management" element={<BoxManagement />} />
                  </Routes>
                </Layout>
              )
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;